// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2ix0Z","title":"ClientInsurance_title__2gu6y","itemText":"ClientInsurance_itemText__1SqLB"};